"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpProvider = exports.providers = void 0;
const tslib_1 = require("tslib");
const HttpProvider_js_1 = tslib_1.__importDefault(require("./HttpProvider.js"));
exports.HttpProvider = HttpProvider_js_1.default;
exports.providers = { HttpProvider: HttpProvider_js_1.default };
//# sourceMappingURL=index.js.map